import type { ButtonDownloadType } from '~/src/types/common'
import type { Ref } from 'vue'

export const handlerButtonDownload = (
  buttonDownload: Ref<ButtonDownloadType>,
) => {
  const button = buttonDownload?.value?.$el
  if (button) button.click()
}
